import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Select, Input } from 'antd';
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
import {sortOptions} from "../../../../Helper/sortObject";
import {TertiaryButton} from "../../../Common/button";
import messages from "./messages";
import {path, LANGUAGE} from "../../../../constant";
const Option = Select.Option;

class AddHealthDistrictAdmin extends Component {
  constructor(props) {
    super(props);
      this.state = {
	  loading:false,
	  status:"",
	  adminName:""
	  
    };
  }


    updateStatus = async () => {
	const {createHealthAdmin, close, data, fetchPublicAdminProfile} = this.props;
	const {status, adminName} = this.state;

	const {public_administration_id} = data;
	const postData = {};
	postData.name = adminName;
	postData.city_id = status;
	postData.public_administration_id = public_administration_id;
	const response = await createHealthAdmin(postData);
	const {status:respStatus, payload} = response;
	if(respStatus){
	    close();
	    fetchPublicAdminProfile(public_administration_id);
	}
	
    }
    
    
    formatMessage = data => this.props.intl.formatMessage(data);

    getOptions = () => {
	const {auth:{cities=[]}={}, data:{governerate_id:selectedGov=""}} = this.props;
	let options = [];
	let citiesToSort = [];
	for(const city of cities){
	    const {id, name, governorate_id} = city;
	    if(governorate_id===selectedGov){
		citiesToSort.push({id, name});
	    }
	}

	const sortMembers = sortOptions(citiesToSort);
	
	for (const city of sortMembers) {
	    options.push(
		    <Option
		key={city.id}
		value={city.id}
		className="medium fontsize14"
		    >
		    {city.name}
		</Option>
	    );
	}

	return options;
    };


    onChangeStatus = (e) => {
	this.setState({status: e});
    };


    onChangeAdmin = (e) => {
	this.setState({adminName:e.target.value});
    };
    
   
    showStatusUI = () => {

	const {close, lang, data:{type=""} = {}} = this.props;
	const {formatMessage, getOptions, onChangeStatus, onChangeAdmin} = this;
	const { status, adminName } = this.state;
	
	let selectIcon;
	if(lang===LANGUAGE.ARAB){
	    selectIcon="ant-select-arrow-rtl";
	}
	else{
	    selectIcon="ant-select-arrow-ltr";
	}

	let msg;
	if(type==="health_admin"){
	    msg = formatMessage(messages.healthAdmin);
	}
	else{
	    msg = formatMessage(messages.healthDistrict);
	}
	
	return (
		<div>
		<div className="flex justify-content-end  mt30 mr40 ml40 clickable" onClick={close}>
		<img src={CloseIcon} alt="close modal"/>
		</div>

		<div className="flex justify-content-center align-items-center mt10 w50 mlauto mrauto">
		<Input placeholder={msg} onChange={onChangeAdmin}/>
	    </div>

	    <div className="flex justify-content-center align-items-center mt10 w50 mlauto mrauto">
	    <Select
	    className={`w100 medium fontsize14 ${selectIcon}`}
	    onChange={onChangeStatus}
	    showSearch={true}
	optionFilterProp="children"
	filterOption={(input, option) =>  
		      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
		      || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
		     }
	    placeholder={formatMessage(messages.city)}
	    dropdownStyle={{ zIndex: 2000 }}
		>
		{getOptions()}
	    </Select>
		</div>
		
		<div className="flex justify-content-center align-items-center mt20">
		<TertiaryButton
	    text={formatMessage(messages.yes)}
            width="wpx120"
	    marginLeft="ml20"
	    marginRight="mr20"
	    handleOnClick={this.updateStatus}
	    disabled={!status || !adminName}
		/>
		</div>
		</div>
	);
    }
    

    render() {
	const {show} = this.props;
	if(!show){
	    return null;
	}

    return (
	    <AcknowledgementLayout>
	    {this.showStatusUI()}
	    </AcknowledgementLayout>
    );
  }
}

export default injectIntl(AddHealthDistrictAdmin);
